import type { ReactNode } from "react";

import { isBrowser } from "../brand/env";

import { SectionNav } from "./SectionNav";
import { VariantToggle } from "./VariantToggle";

/**
 * Page chrome shared by every section: side nav, variant toggle, and a
 * print-friendly main column. The shell is hidden when ?print=1 so the
 * Playwright PDF export captures the body content only.
 */
export function Shell({ children }: { children: ReactNode }) {
  const isPrint =
    isBrowser() &&
    new URLSearchParams(window.location.search).get("print") === "1";

  if (isPrint) {
    return <main className="min-h-screen bg-bg text-ink">{children}</main>;
  }

  return (
    <div className="min-h-screen bg-bg text-ink">
      <SectionNav />
      <VariantToggle />
      <main className="ml-0 md:ml-72 print:ml-0">{children}</main>
    </div>
  );
}
